import { IGenericJSON } from '../helpers/interface';

export class Interest {
  id: number;
  name: string;

  constructor(data: IGenericJSON) {
    this.id = data['id'];
    this.name = data['name'];
  }

  public static digest(data: IGenericJSON): Interest {
    return new Interest(data);
  }

  public static digestResponse(data: IGenericJSON[]): Interest[] {
    const ret: Interest[] = [];
    data.forEach((u: IGenericJSON): void => {
      ret.push(this.digest(u));
    });
    return ret;
  }
}
